import classNames from 'classnames';
import React from 'react';

import {
  compilePath,
  goToPage,
  isActivePath,
  redirect,
} from '../../../utils/navigation';

import styles from './anchor.scss';

const openPage = (
  event: React.KeyboardEvent<HTMLInputElement>,
  href: string,
  isRedirect?: boolean,
): void => {
  if (event.shiftKey || event.ctrlKey || event.metaKey) {
    return;
  }

  event.preventDefault();

  if (isRedirect) {
    redirect(href);
    return;
  }

  goToPage(href);
};

interface Props {
  children: any;
  activeClassName?: string;
  params?: any;
  className?: string;
  dataHook?: string;
  redirect?: boolean;
  path?: string;
  href?: string;
}

const Anchor = ({
  children,
  href,
  path,
  params,
  redirect,
  className,
  activeClassName,
  dataHook,
  ...props
}: Props) => {
  const compiledHref: string = href || compilePath(path, params);

  let customClassNames = {};

  if (activeClassName) {
    customClassNames = {
      [activeClassName]: activeClassName && path && isActivePath(path, params),
    };
  }

  className = classNames(styles.anchor, className, customClassNames);

  return (
    <a
      href={href}
      data-hook={dataHook}
      onClick={(e: any) => openPage(e, compiledHref, redirect)}
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};

export default Anchor;
